export const primaryColor = '#000000';
export const secondaryColor = '#00a3da';
export const secondaryColorDark = '#0198ca';
export const secondaryColorLight = '#cfeeff';
export const redColor = '#ff4757';


